import { LockMinusIcon } from './LockMinusIcon';

/**
 * author: Colton Wiscombe
 * id 1C00C37C-183D-41D7-ACEF-18ACFF70DE80
 * name lock-minus
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-minus.svg
 * tags
 * - Lock 
 */
export const PasswordMinusIcon = LockMinusIcon;
export default PasswordMinusIcon